
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import { init, ECharts, EChartsOption } from 'echarts'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  components: { Table, Charts, Nodata },
  props: {
    itemdata: {
      type: Object,
      default: function() {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    theme: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  setup(props: any, context) {
    const pageData: any = reactive({
      columns: [],
      data: [],
      option: {},
      spinning: true
    })
    const color = globalsets.getColor()
    pageData.columns = [
      {
        title: '日期',
        dataIndex: 'time',
        key: 'time',
        width: '100px',
        fixed: 'left'
      },
      {
        title: '股东人数(户)',
        dataIndex: 'SHNum',
        key: 'SHNum',
        width: '110px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '股东人数变化',
        dataIndex: 'TheChange',
        key: 'TheChange',
        width: '130px',
        slots: { customRender: 'increase' }
      },
      {
        title: '人均流通股(股)',
        dataIndex: 'AFAverageHoldSum',
        key: 'AFAverageHoldSum',
        width: '140px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '人均流通股变化',
        dataIndex: 'AFAverageHoldSumChange',
        key: 'AFAverageHoldSumChange',
        width: '130px',
        slots: { customRender: 'increase' }
      },
      {
        title: '股价(元)',
        dataIndex: 'ClosePrice',
        key: 'ClosePrice',
        width: '100px',
        slots: { customRender: 'decimal' }
      },
      {
        title: '人均持股金额(元)',
        dataIndex: 'AverageHoldSumPrice',
        key: 'AverageHoldSumPrice',
        width: '140px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '十大股东持股合计',
        dataIndex: 'PCTOfTotalShares',
        key: 'PCTOfTotalShares',
        width: '140px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '十大流通股东持股合计',
        dataIndex: 'PCTOfTotalSharesStream',
        key: 'PCTOfTotalSharesStream',
        width: '170px',
        slots: { customRender: 'nocolorincrease' }
      }
    ]
    function setoption() {
      const data = JSON.parse(JSON.stringify(pageData.data))
      const xAxis = data.map((item: any) => item.time).reverse()
      const arr1 = data.map((item: any) => item.SHNum)
      const arr2 = data.map((item: any) => item.ClosePrice)
      const max1 = Math.max.apply(null, arr1)
      const max2 = Math.max.apply(null, arr2) || 0
      let legentcolor = '#7D7D7D'
      if (props.theme === 'dark') {
        legentcolor = '#7D7D7D'
      }
      pageData.option = {
        color: color,
        tooltip: {
          trigger: 'axis',
          formatter: function(params: any) {
            var htmlStr = ''
            htmlStr += '<div class="optiontooltip"><p style="color:rgba(0,0,0,0.45);">' + params[0].name + '</p>'
            for (var i = 0; i < params.length; i++) {
              // 前面的原点和他的颜色
              let style = 'height: 8px;'
              if (i === 1) {
                style = 'height: 2px;'
              }
              htmlStr +=
                '<span style="width: 8px;' +
                style +
                'vertical-align: middle;display:inline-block;margn-right: 4px;background-color:' +
                params[i].color +
                '"></span><span style="color:#000;margin-left: 6px;">' +
                params[i].seriesName +
                ':</span>' +
                '<span style="color:#000;float:right;margin-left: 12px">' +
                globalsets.getNumber(params[i].value) +
                '</span><br/>'
            }
            htmlStr += '</div>'
            return htmlStr
          }
        },
        grid: [
          {
            top: 40,
            left: max1 < 10 ? 32 : max1 < 100 ? 24 : 10,
            right: 30,
            bottom: 50,
            containLabel: true
          }
        ],
        toolbox: {
          feature: {}
        },
        legend: [
          {
            bottom: 20,
            itemWidth: 8,
            left: '390',
            itemHeight: 8,
            data: [
              {
                name: '股东人数（户）', // 图例文字内容
                icon: 'rect',
                textStyle: {
                  color: '#7D7D7D'
                }
              }
            ]
          },
          {
            bottom: 20,
            itemWidth: 8,
            left: '500',
            itemHeight: 2,
            data: [
              {
                name: '股价（元）', // 图例文字内容
                icon: 'rect',
                textStyle: {
                  color: '#7D7D7D'
                }
              }
            ]
          }
        ],
        xAxis: [
          {
            type: 'category',
            data: xAxis,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            name: '股东人数（户）',
            type: 'value',
            interval: Math.ceil(Math.ceil(max1) / 5),
            max: Math.ceil(Math.ceil(max1) / 5) * 5
          },
          {
            name: '股价（元）',
            type: 'value',
            // max: Math.ceil(max2),
            interval: Math.ceil(Math.ceil(max2) / 5),
            max: Math.ceil(Math.ceil(max2) / 5) * 5,
            axisLabel: {
              formatter: function(value: any) {
                return (value || 0).toFixed(2)
              }
            }
          }
        ],
        series: [
          {
            name: '股东人数（户）',
            type: 'bar',
            yAxisIndex: 0,
            barWidth: 20,
            data: data.map((item: any) => item.SHNum).reverse()
          },
          {
            name: '股价（元）',
            type: 'line',
            yAxisIndex: 1,
            lineStyle: {
              width: 1
            },
            showSymbol: false,
            data: data.map((item: any) => item.ClosePrice).reverse()
          }
        ]
      }
    }
    // ShareholderNum
    watch(
      () => (props.pageSourceData || {}).ShareholderNum,
      (val: any) => {
        const data = JSON.parse(JSON.stringify(val))
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'ShareholderNum' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
          pageData.data = data
        }
        nextTick(() => {
          pageData.spinning = false
          setoption()
        })
      },
      { deep: true }
    )

    return {
      ...toRefs(pageData)
    }
  }
})
